module.exports = __webpack_public_path__ + "media/images/athletes/1627-4b1fe131e83b1da31bff17151daab292.png";